import React, { useEffect } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import Footer from "./Footer";

const Careercs1 = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when component loads
  }, []);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const sections = [
    {
      title: "Innovate, challenge and drive change",
      description:
        "When you join Tech Informatic Solutions, you join a collaborative, agile working environment that stretches your thinking and encourages innovation and an entrepreneurial spirit. You also become part of a culture that is rooted in respect, empowered to experiment and to learn from failure. At Tech Informatic Solutions, we expect you to step outside your comfort zone. Here, you can be confident to innovate, challenge and drive change. Your voice is listened to, valued and has genuine impact, because experience has taught us that we achieve far more together than we can alone.",
      image: "/image/innovationimg.png",
    },
    {
      title: "Find a place to learn, develop and grow",
      description:
        "Present in almost 185 countries, we offer a global platform for you to learn, develop and grow to your full potential. The scale of our business offers global career opportunities across different brands and products, and the opportunity to learn from the diverse range of skills and backgrounds of the colleagues around you. We both challenge and empower you to be the best version of yourself. Own your progress and be curious, flexible and ambitious to learn.",
      image: "/image/educationcs1.jpg",
    },
  ];

  return (
    <Box sx={{ backgroundColor: "#C4D8E2" }}>

      {/* Hero Section */}
      <Box
        sx={{
          height: { xs: "60vh", md: "70vh" }, // reduced height
          backgroundImage: `url('/image/career.jpg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          px: { xs: 3, md: "96px" }, // 1 inch = 96px approx
        }}
      >
        <Box maxWidth="1200px" p={4} borderRadius={2}>
          <Typography
            variant="h1"
            sx={{
              color: "white",
              fontWeight: "bold",
              fontSize: { xs: "50px", md: "70px" },
            }}
          >
            Working at Tech Informatic Solutions
          </Typography>
        </Box>
      </Box>

      {/* Business Needs Section */}
      <Box sx={{ px: { xs: 3, md: "96px" }, py: 10 }}>
        <Typography variant="h3" fontWeight="bold" mb={6}>
          A community of people with a shared purpose
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontSize: "18px", color: "#333", mb: 3 }}
        >
          At Tech Informatic Solutions, we believe in the power of food to enhance
          quality of life for everyone. Guided by this purpose, we constantly aim
          to push the boundaries of what's possible with food, beverages, and
          nutritional health solutions.
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontSize: "18px", color: "#333", mb: 3 }}
        >
          Our people make this possible. They are behind the strength of our brands,
          the quality of our products and the future of our business. Their ideas
          and efforts push our boundaries, drive innovation and help us to
          continually improve, deliver and succeed.
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontSize: "18px", color: "#333" }}
        >
          Discover how you can help shape our future and make an impact every day.
        </Typography>
      </Box>

      <Box
      sx={{
        width: "100%",
        backgroundColor: "#C4D8E2",
        paddingLeft: isMobile ? "1.5rem" : "1in",  // Minor padding on mobile
        paddingRight: isMobile ? "1.5rem" : "1in", // Minor padding on mobile
        boxSizing: "border-box",
      }}
    >
      {sections.map((section, index) => (
        <Box
          key={index}
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row", // Adjust flex direction based on screen size
            alignItems: "center",
            justifyContent: "space-between",
            gap: 4,
            marginBottom: "60px",
            paddingLeft: isMobile ? "0" : "1rem", // No padding on mobile
            paddingRight: isMobile ? "0" : "1rem", // No padding on mobile
          }}
        >
          {/* 📝 Left Text */}
          <Box sx={{ flex: 1, textAlign: isMobile ? "left" : "left" }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 500,
                fontSize: isMobile ? "28px" : "36px",
                marginBottom: 2,
              }}
            >
              {section.title}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: isMobile ? "18px" : "18px",
                color: "#333",
                lineHeight: 1.6,
              }}
            >
              {section.description}
            </Typography>
          </Box>

          {/* 🖼️ Right Image Box */}
          <Box
            sx={{
              flex: 1,
              maxWidth: "500px", // ✅ Prevent overflow
              backgroundColor: "white",
              borderRadius: "10px",
              overflow: "hidden",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              boxShadow: `
                0px 12px 25px rgba(0, 0, 0, 0.6),  
                inset 0px 10px 20px rgba(255, 255, 255, 0.15),
                inset 0px -10px 30px rgba(0, 0, 0, 0.7),
                inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
                inset -10px 0px 20px rgba(255, 255, 255, 0.2)
              `,
              marginBottom: isMobile ? "20px" : "0", // Reduce bottom margin in mobile view
            }}
          >
            <img
              src={section.image}
              alt={section.title}
              style={{
                width: "100%",
                height: index === 0 ? "280px" : "auto", // ✅ Shorter height for first image
                objectFit: "cover",
                borderRadius: "10px",
              }}
            />
          </Box>
        </Box>
      ))}
    </Box>


      <Footer />
    </Box>
  );
};

export default Careercs1;
